var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wysiwyg-content my-3"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.content.content)}},[_vm._v("\n    "+_vm._s(_vm.item.content.content)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }